var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',[_c('v-overlay',{attrs:{"absolute":"","color":"#ffffff","opacity":"0.7","z-index":_vm.zIndex}},[_c('div',[_c('LoadingIcon',{attrs:{"color":_vm.colour,"progress":_vm.progress}})],1)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }